import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    isSideMenuOpen: false
  }),
  actions: {
    openSideMenu() {
      this.isSideMenuOpen = true
    },
    closeSideMenu() {
      this.isSideMenuOpen = false
    }
  }
})
